import React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from './styles/globalStyles';
import * as serviceworker from './serviceWorker';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CssBaseline>
      <GlobalStyles />
      <App />
    </CssBaseline>
  </React.StrictMode>,
);

serviceworker.unregister();
